import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useEffect, useState } from 'react';
import Button from '../Button';
import { useTranslation } from 'react-i18next';
import PenIcon from '../../assets/icons/pen.svg';
import Switch from '../Switch';
import ButtonsGroup from '../ButtonsGroup';
import DeleteIcon from '../../assets/icons/delete.svg';
import { useSelector } from 'react-redux';
import { selectInstitutionsCurrentPage, selectInstitutionToDeactivate, setInstitutions, setInstitutionToDeactivate, } from '../../store/adminSlices/institutions';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '../../app.config.vars/routes';
import { setIsModalOpen, setModalContent, setModalContentProps } from '../../store/slices/global';
import { MODAL_CONTENT } from '../../app.config.vars/modalContent';
import { getInstitutions, mapInstitutionsResponse, updateInstitution, } from '../../api/admin/institutions';
import { useAppDispatch } from '../../store';
import { getEditors, getEditorsPerInstitution, updateEditor } from '../../api/admin/editors';
import { selectEditorsCurrentPage, selectEditorToDeactivate, setEditors, setEditorToDeactivate, } from '../../store/adminSlices/editors';
import { generateIdRoutePath } from '../../helpers';
import DocumentIcon from '../../assets/icons/document.svg';
const SuperAdminUnitCard = ({ unitId, unit, name, email, isActive, onUnitEdit, submitStatus, setSubmitStatus, institutionId, newDocument, currentPage, approvalStatus, editorCount, }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [isSwitchChecked, setIsSwitchChecked] = useState(isActive);
    const institutionToDeactivate = useSelector(selectInstitutionToDeactivate);
    const editorToDeactivate = useSelector(selectEditorToDeactivate);
    const institutionsCurrentPage = useSelector(selectInstitutionsCurrentPage);
    const editorsCurrentPage = useSelector(selectEditorsCurrentPage);
    useEffect(() => {
        setIsSwitchChecked(isActive);
    }, [isActive]);
    const handleError = () => {
        setSubmitStatus('error');
        dispatch(setIsModalOpen(true));
        dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
    };
    const closeModal = () => {
        dispatch(setIsModalOpen(false));
        dispatch(setModalContent(null));
    };
    const setInstitutionIsActive = async (isActive, deactivateRallies) => {
        setSubmitStatus('pending');
        try {
            await updateInstitution(institutionToDeactivate ? String(institutionToDeactivate.id) : String(unitId), { isActive, deactivateRallies });
            const institutions = await getInstitutions(institutionsCurrentPage);
            dispatch(setInstitutions(mapInstitutionsResponse(institutions)));
            setSubmitStatus('success');
            dispatch(setInstitutionToDeactivate(null));
            closeModal();
        }
        catch (_) {
            handleError();
        }
    };
    const setEditorIsActive = async (isActive, deactivateRallies) => {
        setSubmitStatus('pending');
        try {
            await updateEditor(editorToDeactivate ? String(editorToDeactivate.id) : String(unitId), {
                isActive,
                deactivateRallies,
            });
            let editors;
            if (institutionId) {
                editors = await getEditorsPerInstitution(institutionId, editorsCurrentPage);
            }
            else {
                editors = await getEditors(editorsCurrentPage);
            }
            dispatch(setEditors(editors.data));
            setSubmitStatus('success');
            dispatch(setEditorToDeactivate(null));
            closeModal();
        }
        catch (_) {
            handleError();
        }
    };
    useEffect(() => {
        if (institutionToDeactivate && institutionToDeactivate.id === unitId) {
            setInstitutionIsActive(false, institutionToDeactivate.deactivateRallies);
        }
        if (editorToDeactivate && editorToDeactivate.id === unitId) {
            setEditorIsActive(false, editorToDeactivate.deactivateRallies);
        }
    }, [institutionToDeactivate, editorToDeactivate]);
    const handleSwitchChange = async () => {
        if (submitStatus === 'pending') {
            return;
        }
        if (isSwitchChecked) {
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.deactivateAdminUnit.key));
            dispatch(setModalContentProps({ unitId, unit }));
        }
        else {
            try {
                if (unit === 'institution') {
                    await setInstitutionIsActive(true);
                }
                if (unit === 'editor') {
                    await setEditorIsActive(true);
                }
            }
            catch (_) {
                handleError();
            }
        }
    };
    const onDeleteAdminUnit = () => {
        dispatch(setIsModalOpen(true));
        dispatch(setModalContent(MODAL_CONTENT.confirmDeleteAdminUnit.key));
        dispatch(setModalContentProps({
            unitId,
            unit,
            institutionId,
        }));
    };
    const showVerificationDocuments = async () => {
        dispatch(setIsModalOpen(true));
        dispatch(setModalContent(MODAL_CONTENT.institutionVerificationData.key));
        dispatch(setModalContentProps({ institutionId: unitId, currentPage, approvalStatus }));
    };
    return (_jsxs("div", { className: `super-admin-unit-card ${unit}-card`, children: [_jsxs("div", { className: "super-admin-unit-card-wrapper", children: [_jsx("div", { className: "unit-name", children: name }), _jsx("div", { className: "unit-email", children: email }), unit === 'institution' && editorCount !== undefined && (_jsx("div", { className: "unit-editor-count", children: t('admin.editor_count', { count: editorCount }) }))] }), _jsxs("div", { className: "super-admin-unit-card-controls", children: [_jsx("div", { className: "switcher", children: _jsx(Switch, { checked: isSwitchChecked, onChange: handleSwitchChange, labelLeft: t('label.active'), labelRight: t('label.inactive') }) }), _jsxs(ButtonsGroup, { wrap: 'nowrap', children: [unit === 'institution' && (_jsx(Button, { onClick: () => navigate(generateIdRoutePath(APP_ROUTES.editorsPerInstitution, String(unitId))), label: t('button.editors'), variant: 'outlined' })), _jsx(Button, { onClick: onUnitEdit, variant: 'outlined', icon: _jsx(PenIcon, {}), manageIcon: 'fill', shape: 'square' }), _jsx(Button, { onClick: onDeleteAdminUnit, variant: 'outlined', shape: 'square', icon: _jsx(DeleteIcon, {}), manageIcon: 'fill' }), unit === 'institution' && (_jsxs("div", { className: "indicator-button", children: [_jsx(Button, { onClick: showVerificationDocuments, variant: 'outlined', shape: 'square', icon: _jsx(DocumentIcon, {}), manageIcon: 'fill', disabled: approvalStatus === 'new' }), newDocument && _jsx("span", { className: 'indicator-dot' })] }))] })] })] }));
};
export default SuperAdminUnitCard;
